import Footer from '../layouts/Footer';
import Section1 from '../components/landing/Section1';
import Section10 from '../components/landing/Section10';
import Section2 from '../components/landing/Section2';
import AppLayout from '../layouts/AppLayout';
import AuthLayout from '../layouts/AuthLayout';
import Login from './Login';

const Home = () => (
  <>
    {/* <Section1 />
    <Section2 />
    <Section10 />
    <Footer /> */}
    <Login />
  </>
);

export default Home;
